<template>
  <div>
    <div class="md-layout studio-nav">
      <div class="md-layout-item">
        <div class="md-layout md-alignment-top-left">
          <md-button
            class="md-primary prev-nav-button"
            :disabled="prevDisable"
            @click="prev"
          >
            Previous Studio
          </md-button>
        </div>
      </div>
      <div class="md-layout-item">
        <div class="md-layout md-alignment-top-right">
          <md-button
            class="md-primary next-nav-button"
            :disabled="nextDisable"
            @click="next"
          >
            Next Studio
          </md-button>
        </div>
      </div>
    </div>
    <div class="navigation-indicators">
      <div class="md-layout md-alignment-center-center indicators">
        <template v-for="(studioId, index) in studios">
          <div 
            :key="index"
            :class="{ 'active': studioId === id }"
            @click="showStudio(studioId)"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StudioNavigation",
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    studios: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    prevDisable() {
      return this.currentIndex === 0
    },
    nextDisable() {
      return this.currentIndex === this.studios.length - 1
    }
  },
  watch: {
    studios () {
      this.setIndex()
    }
  },
  created() {
    this.setIndex()
  },
  methods: {
    resetData() {
      this.$store.commit('setStudioDetails', [])
      this.$store.commit('setStudioProjects', [])
      this.$store.commit('setArtists', [])
    },
    setIndex() {
      this.currentIndex = this.studios.findIndex((value)=> {
        return value === this.id
      })
    },
    async goToStudio() {
      this.resetData()
      this.$emit('scroll', true)
      await this.$nextTick()
      this.$router.push(`/studios/${this.studios[this.currentIndex]}`)
    },
    prev() {
      if (this.currentIndex >= 0) {
        this.currentIndex -= 1
        this.goToStudio()
      }
    },
    next() {
      if (this.currentIndex >= 0) {
        this.currentIndex += 1
        this.goToStudio()
      }
    },
    showStudio(id) {
      this.$emit('scroll', true)
      this.$router.push(`/studios/${id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-button {
  width: 162px;
  height: 44px;
  margin-left: 0px;
  background-color: $color-primary !important;
  color: $color-white !important;
  font-size: 12px;
  font-weight: 500; 
  text-align: center; 
  &:disabled {
    background-color: #f2f2f2 !important;
  }
}
.prev-nav-button {
  @extend .nav-button;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}
.next-nav-button {
  @extend .nav-button;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}
.navigation-indicators {
  min-height: 100px;
  max-height: 100px;
  margin-top: 25px;
  .indicators {
    div {
      width: 15px;
      height: 15px;
      background-color: #d8d8d8;
      border-radius: 50%;
      cursor: pointer;
      &:not(:last-child) {
        margin-right: 12px;
      }
      &.active {
        width: 67px;
        height: 15px;
        border-radius: 7.5px;
        background-color: $color-primary;
      }
    }
  }
  p {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #505d68;
  }
}
</style>